import { render, staticRenderFns } from "./ContractReminders.vue?vue&type=template&id=2d109e6e&"
import script from "./ContractReminders.vue?vue&type=script&lang=ts&"
export * from "./ContractReminders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports